module.exports = __webpack_public_path__ + "img/IIAFvsETF.6d751a69.png";